import { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { useStoreContext } from "../../../contexts/StoreProvider";
import { sanitizeUser } from "../../../contexts/AuthProvider/utils";

export const AUTH_TOKEN_REFRESH = gql`
  mutation AuthTokenRefresh($id: ID) {
    authTokenRefresh(userId: $id) {
      user {
        id
        email
        first_name
        last_name
        role {
          id
          name
          description
          type
        }
        password_updated_at
        mfa_enabled
      }
    }
  }
`;

const TIME_INTERVAL = 1000 * 60 * 10; // default 10 minutes

const AuthChecker = () => {
  const {
    dispatch,
    state: { user },
  } = useStoreContext();
  const [, setBoundaryError] = useState<Error | null>(null);
  const [authTokenRefresh] = useMutation(AUTH_TOKEN_REFRESH, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      dispatch({
        type: "UPDATE_USER",
        payload: sanitizeUser(data.authTokenRefresh.user),
      });
      return null;
    },
    onError: (error) => {
      // Ignore "Forbidden access" — happens when JWT is not yet valid (e.g. MFA in progress)
      if (error.message === "Forbidden access") return;
      setBoundaryError(() => {
        throw error;
      });
    },
  });

  useEffect(() => {
    if (!user?.id) return;

    const refreshAuthToken = async () => {
      await authTokenRefresh({
        variables: {
          id: user.id,
        },
      });
    };

    refreshAuthToken();
    const warningPoll = setInterval(refreshAuthToken, TIME_INTERVAL);
    return () => clearInterval(warningPoll);
  }, [authTokenRefresh, user?.id]);

  return <></>;
};

export default AuthChecker;
